(function () {
  'use strict';

  angular
    .module('settings.customization.custom.field')
    .directive(
      'settingsCustomizationCustomField',
      settingsCustomizationCustomField,
    );

  settingsCustomizationCustomField.$inject = [];

  function settingsCustomizationCustomField() {
    var directive = {
      bindToController: true,
      controller: 'SettingsCustomizationCustomFieldCtrl',
      controllerAs: 'vm',
      template: require('../settings.customization.custom.field/table.html'),
      link: link,
      scope: {
        customFieldFor: '@',
        title: '@',
      },
      restrict: 'E',
      replace: true,
    };
    return directive;

    function link(scope, element, attrs, ctrl) {}
  }
})();
